<template>
    <div class="test-statistics-sessions">
        <test-page-header
            :title="title"
            :is-one-line-title="true"
            :return-button="returnButton"
        />

        <div class="test-statistics-sessions__content fixed-with-overflow-y small-scrollbar">
            <statistics-question-text-block
                v-if="testStatisticQuestion"
                class="my-1"
                :text="testStatisticQuestion.text"
            />

            <test-statistics-table
                :table-data="testStatisticSessions"
                :headers="tableHeaders"
                :link-collback="showSessionDetails"
            />
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TestStatisticsTable from "./TestStatisticsTable";
import {userSessionsTable} from "../../../../config/tests/statisticsTables";
import StatisticsQuestionTextBlock from "./questions/StatisticsQuestionTextBlock";

export default {
    name: "TestStatisticsSessions",
    components: {StatisticsQuestionTextBlock, TestStatisticsTable},
    data() {
        return {
            tableHeaders: userSessionsTable,
        };
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testStatisticSessions',
            'testStatisticUser',
            'testStatisticQuestion',
        ]),
        returnButton() {
            return {
                text: this.trans.statistics.return_button,
                handler: this.returnToTestStatisticsPage,
            }
        },
        title() {
            return this.trans.statistics.user_table_title + this.testStatisticUser.title;
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestStatisticsPage',
            'showTestStatisticDetail'
        ]),
        showSessionDetails(session) {
            this.showTestStatisticDetail(session);
        }
    }
}
</script>

<style scoped lang="scss">
    .test-statistics-sessions__content {
        font-size: 18px;
    }
</style>